import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

export type VirtualScrollMove = {
  /** The viewport moved further down than the last time it was read. */
  scrolledDown: boolean;
  /** False when the content does not overflow the viewport, so there is nothing to scroll. */
  canScroll: boolean;
  /** Pixels between the current position and the end of the content. */
  distanceToBottom: number;
};

export class VirtualScrollTracker {
  private lastOffset = 0;

  read(viewport: CdkVirtualScrollViewport): VirtualScrollMove {
    const offset = viewport.measureScrollOffset('top');
    const distanceToBottom = viewport.measureScrollOffset('bottom');
    const scrolledDown = offset > this.lastOffset;

    this.lastOffset = offset;

    return { scrolledDown, canScroll: offset > 0 || distanceToBottom > 0, distanceToBottom };
  }
}
